import { LinearGradient, RadialGradient } from "../types/Gradient"
import { WithShape } from "../traits/Shape"
import { FillProperties } from "../traits/Fill"
import {
    elementPropertiesForLinearGradient,
    LinearGradientElementProperties,
    elementPropertiesForRadialGradient,
    RadialGradientElementProperties,
} from "./elementPropertiesForGradient"

export function gradientForShape(
    nodeId: string,
    node: WithShape & FillProperties
): LinearGradientElementProperties | RadialGradientElementProperties | undefined {
    if (LinearGradient.isLinearGradient(node.fill)) {
        return elementPropertiesForLinearGradient(node.fill, nodeId)
    }
    if (RadialGradient.isRadialGradient(node.fill)) {
        return elementPropertiesForRadialGradient(node.fill, nodeId)
    }
    return undefined
}
